<template lang="pug">
#visualizar-inteligencia-carbono
    BaseHeader(
        titulo='Gestão de ativos ambientais',
        :breadcrumb='breadcrumb',
        :exibeBotao='false',
        :voltarPara='true'
    )
        template(slot='direita')
            el-popover(placement='bottom', width='350', trigger='click')
                BaseButton.ferramentas-btn(type='primary', slot='reference')
                    i.mdi.mdi-wrench-outline.mdi-flip-h
                    | Ferramentas

                .ferramentas-opcoes
                    .ferramentas-opcoes--bloco
                        p Ferramentas
                        .ferramentas-opcoes--bloco--item
                            i.mdi.mdi-calculator
                            | Calculadora de PSA

                        .ferramentas-opcoes--bloco--item
                            i.mdi.mdi-calculator
                            | Calculadora de crédito de carbono (REDD+)

                    .ferramentas-opcoes--bloco
                        p Templates
                        .ferramentas-opcoes--bloco--item
                            i.mdi.mdi-sprout-outline
                            | Template de crédito agricola

                    .ferramentas-opcoes--bloco
                        p Compartilhamento
                        .ferramentas-opcoes--bloco--item
                            i.mdi.mdi-link-variant
                            | Compartilhar link

                        .ferramentas-opcoes--bloco--item
                            i.mdi.mdi-file-download-outline
                            | {{ $t('mensagens.laudos.exportarDados') }}

    FiltrarInteligenciaCarbono(
        :isMonitoramentoSocioambiental='true',
        @atualizar-filtro='atualizarFiltro'
    )

    .view-container.secao-container
        BlocoVisualizarDados(
            @atualizar-filtro-avancado='atualizarFiltroCategoriaTag'
        )
        .secao-container--conteudo
            h3 Biomas
            .secao-container--conteudo--interno.verde
                BlocoBiomas(
                    titulo='Amazônia',
                    valor='39%',
                    valorArea='825.225',
                    imoveis='1.898.251'
                )
                BlocoBiomas(
                    titulo='Cerrado',
                    valor='38%',
                    valorArea='785.245.225',
                    imoveis='2.898.251'
                )
                BlocoBiomas(
                    titulo='Mata Atlântica',
                    valor='39%',
                    valorArea='825.225',
                    imoveis='1.898.251'
                )
                BlocoBiomas(
                    titulo='Caatinga',
                    valor='38%',
                    valorArea='785.245.225',
                    imoveis='2.898.251'
                )
                BlocoBiomas(titulo='Pampa', valor='', valorArea='', imoveis='')
                BlocoBiomas(
                    titulo='Pantanal',
                    valor='',
                    valorArea='',
                    imoveis=''
                )

        .secao-container--bloco
            .secao-container--bloco--alinhamento
                .secao-container--bloco--alinhamento--subtitulo
                    h3 Imóveis
                    span.mdi.mdi-alert-circle-outline
                .secao-container--conteudo--interno
                    BlocoImovel(
                        imoveisValor='6.521.253',
                        areaValor='1.652.044.775 ha',
                        media='253 ha',
                        valorMenor='3.980.160 - 61%',
                        valorMedio='18.377 ha - 1,75%',
                        valorMaior='2.235.377 - 34%'
                    )

            .secao-container--bloco--alinhamento
                .secao-container--bloco--alinhamento--ajustes
                    h3 Não conformidades socioambientais
                    span.mdi.mdi-alert-circle-outline
                .secao-container--conteudo--interno
                    BlocoSocioAmbiental(
                        totalImoveis='552.123',
                        bloqueadosValor='158.456',
                        alertasValor='393.667',
                        desmatamentos='367.142 - 75%',
                        embargos='125.132- 18%',
                        socialValor='15.236 - 6%',
                        areasProtegidas='10.745  - 3%'
                    )

            .secao-container--bloco--alinhamento
                .secao-container--bloco--alinhamento--subtitulo
                    h3 Regularização
                    span.mdi.mdi-alert-circle-outline
                .secao-container--conteudo--interno
                    BlocoRegularizacao(
                        imoveisValor='625.360',
                        areaValor='21.256.245 ha',
                        reservaLegal='13.256.000 ha',
                        deficitApp='5.256.050 ha',
                        deficitVegetacao='26.512.295 ha'
                    )

            .secao-container--bloco--alinhamento
                .secao-container--bloco--alinhamento--subtitulo
                    h3 Potencial de PSA
                    span.mdi.mdi-alert-circle-outline
                .secao-container--conteudo--interno
                    BlocoPotencialPSA(
                        imoveisValor='253.210',
                        areaValor='320.256.356 ha',
                        areasConservacao='150.256.560 ha',
                        nascentes='120.236'
                    )

            .secao-container--bloco--alinhamento
                .secao-container--bloco--alinhamento--subtitulo
                    h3 Ativos Ambientais
                    span.mdi.mdi-alert-circle-outline
                .secao-container--conteudo--interno
                    BlocoAtivosAmbientais(
                        imoveisValor='253.210',
                        areaReserva='123.256.356 ha',
                        areaApp='110.256.356 ha',
                        vegetacao='75.256.356 ha',
                        carbono='8.845.256.356 tonC'
                    )
        .secao-container--ranking
            h3 Ranking de unidade federativa em relação a categoria selecionada
            RankingCategoria
</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import FiltrarInteligenciaCarbono from '@/components/inteligenciaCarbono/FiltrarInteligenciaCarbono';
import BlocoBiomas from '@/components/inteligenciaCarbono/BlocoBiomas';
import BlocoImovel from '@/components/inteligenciaCarbono/BlocoImovel';
import BlocoSocioAmbiental from '@/components/inteligenciaCarbono/BlocoSocioAmbiental';
import BlocoRegularizacao from '@/components/inteligenciaCarbono/BlocoRegularizacao';
import BlocoPotencialPSA from '@/components/inteligenciaCarbono/BlocoPotencialPSA';
import BlocoAtivosAmbientais from '@/components/inteligenciaCarbono/BlocoAtivosAmbientais';
import RankingCategoria from '@/components/inteligenciaCarbono/RankingCategoria';
import BlocoVisualizarDados from '@/components/inteligenciaCarbono/BlocoVisualizarDados';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'VisualizarInteligenciaCarbono',
    components: {
        BaseHeader,
        BlocoVisualizarDados,
        FiltrarInteligenciaCarbono,
        BlocoBiomas,
        BlocoImovel,
        BlocoSocioAmbiental,
        BlocoRegularizacao,
        BlocoPotencialPSA,
        BlocoAtivosAmbientais,
        RankingCategoria,
        BaseButton
    },
    data() {
        return {
            value: '',
            breadcrumb: [
                { nome: 'Visão geral', rota: 'visualizar-carbono-imovel' }
            ]
        };
    },

    methods: {
        atualizarFiltro() {},
        atualizarFiltroAvancado(filtros) {},
        atualizarFiltroCategoriaTag(filtros) {}
    }
};
</script>

<style lang="scss" scoped>
#visualizar-inteligencia-carbono {
    .secao-container {
        margin-top: 20px;
        margin-bottom: 20px;
        .secao-container--conteudo {
            margin-top: 20px;
            h3 {
                font-weight: 600;
            }
        }
        .secao-container--ranking {
            margin-top: 20px;
            h3 {
                font-weight: 600;
                margin-bottom: 10px;
            }
        }
        .secao-container--conteudo--interno {
            display: flex;
            justify-content: space-between;
            margin-top: 7px;
        }

        &--bloco {
            margin-top: 20px;
            display: flex;
            h3 {
                font-weight: 600;
                height: 35px;
                display: flex;
                align-items: center;
            }
            &--alinhamento {
                min-width: 20%;
                padding: 2px;

                &--subtitulo {
                    display: flex;
                    align-items: center;
                }
                &--ajustes {
                    display: flex;
                    align-items: center;
                    width: 75%;
                }
            }
        }
    }
    span.mdi.mdi-alert-circle-outline {
        margin-left: 5px;
        font-size: 20px;
    }
}
.ferramentas-btn {
    i {
        margin-right: 7px;
    }
}
.ferramentas-opcoes {
    .ferramentas-opcoes--bloco {
        margin-bottom: 18px;

        p {
            color: var(--primary);
            font-weight: 600;
        }
        .ferramentas-opcoes--bloco--item {
            color: var(--primary);
            font-size: 13px;
            margin-bottom: 8px;
            margin-left: 14px;
            cursor: pointer;
            i {
                margin-right: 5px;
            }
        }
        .ferramentas-opcoes--bloco--item:hover {
            color: var(--secondary) !important;
        }
    }
}
</style>
